<div
  class="field-dialog__content__scroll p-24 tab-maintenances"
  fxLayout="column"
  #tabElement
  fusePerfectScrollbar
  (scroll)="onScroll()"
>
  <div *ngIf="!this.isLoading && !maintenances.length" class="tab-maintenances__no-items">
    <mat-icon class="tab-maintenances__no-items-icon">search_off</mat-icon>
    <p class="tab-maintenances__no-items-text">
      {{ 'LOCATION_SECTOR_DIALOG.TAB.MAINTENANCES.NO_MAINTENANCES' | translate }}
    </p>
  </div>

  <div *ngIf="maintenances.length" class="tab-maintenances__content">
    <!--
    <div class="tab-maintenances__content__go-to-page" matRipple (click)="toMaintenancesPage()">
      <p class="tab-maintenances__content__go-to-page_text">
        {{ 'LOCATION_SECTOR_DIALOG.TAB.MAINTENANCES.GO_TO_PAGE' | translate }}
      </p>
      <mat-icon class="tab-maintenances__content__go-to-page_icon"> arrow_forward </mat-icon>
    </div>
    -->

    <div class="tab-maintenances__content__item" *ngFor="let maintenance of maintenances">
      <div class="tab-maintenances__content__item__lollipop">
        <div
          class="tab-maintenances__content__item__lollipop__circle"
          [ngClass]="'tab-maintenances__content__item__lollipop__circle--' + maintenance.status"
        >
          <mat-icon class="tab-maintenances__content__item__lollipop__circle-icon">
            {{ maintenance.status | statusIconMaintenance }}
          </mat-icon>
        </div>
        <div class="tab-maintenances__content__item__lollipop-line"></div>
      </div>
      <div class="tab-maintenances__content__item__card">
        <div class="tab-maintenances__content__item__card__header">
          <div class="tab-maintenances__content__item__card__header__column">
            <img
              *ngIf="maintenance.company"
              [src]="
                maintenance.company.avatarUrl || 'https://ui-avatars.com/api/?name=' + (maintenance.company.name || '')
              "
              class="tab-maintenances__content__item__card__header__column-picture"
              [alt]="maintenance.company.name"
            />
            <div class="tab-maintenances__content__item__card__header__column__text">
              <p class="tab-maintenances__content__item__card__header__column__text-title">
                {{ maintenance.number }} - {{ maintenance.maintenanceType.name }}
              </p>
              <p
                class="tab-maintenances__content__item__card__header__column__text-status"
                [ngClass]="'tab-maintenances__content__item__card__header__column__text-status--' + maintenance.status"
              >
                {{ maintenance.status | statusMaintenance }}
              </p>
            </div>
          </div>

          <div class="tab-maintenances__content__item__card__header__column">
            <p class="tab-maintenances__content__item__card__header__column-date">
              {{
                'LOCATION_SECTOR_DIALOG.TAB.MAINTENANCES.ITEM.OPENED_AT'
                  | translate
                    : {
                        date: maintenance.openedAt | date: 'dd/MM/yyyy HH:mm'
                      }
              }}
            </p>
          </div>
        </div>

        <div class="tab-maintenances__content__item__card__content">
          <p
            class="tab-maintenances__content__item__card__content-text"
            *ngIf="maintenance.company"
            [innerHTML]="
              'LOCATION_SECTOR_DIALOG.TAB.MAINTENANCES.ITEM.OWNER_COMPANY'
                | translate
                  : {
                      company: maintenance.company.name
                    }
            "
          ></p>
          <p
            class="tab-maintenances__content__item__card__content-text"
            *ngIf="!maintenance.company"
            [innerHTML]="'LOCATION_SECTOR_DIALOG.TAB.MAINTENANCES.ITEM.NO_OWNER_COMPANY' | translate"
          ></p>
          <p
            class="tab-maintenances__content__item__card__content-text"
            *ngIf="maintenance.scheduled && maintenance.scheduled.date"
            [innerHTML]="
              'LOCATION_SECTOR_DIALOG.TAB.MAINTENANCES.ITEM.SCHEDULED_AT'
                | translate
                  : {
                      scheduledAt: (maintenance.scheduled | concatDateAndTime)
                    }
            "
          ></p>
          <p
            class="tab-maintenances__content__item__card__content-text"
            *ngIf="maintenance.scheduled && !maintenance.scheduled.date"
            [innerHTML]="'LOCATION_SECTOR_DIALOG.TAB.MAINTENANCES.ITEM.NO_SCHEDULED_AT' | translate"
          ></p>
          <p
            class="tab-maintenances__content__item__card__content-text"
            *ngIf="maintenance.firstVisitStartedAt"
            [innerHTML]="
              'LOCATION_SECTOR_DIALOG.TAB.MAINTENANCES.ITEM.STARTED_AT'
                | translate
                  : {
                      startedAt: (maintenance.firstVisitStartedAt | date: 'dd/MM/yyyy HH:mm')
                    }
            "
          ></p>
          <p
            class="tab-maintenances__content__item__card__content-text"
            *ngIf="!maintenance.firstVisitStartedAt"
            [innerHTML]="'LOCATION_SECTOR_DIALOG.TAB.MAINTENANCES.ITEM.NO_STARTED_AT' | translate"
          ></p>
        </div>

        <div class="tab-maintenances__content__item__card__footer">
          <button type="button" mat-stroked-button color="primary" (click)="openMaintenanceDialog(maintenance.id)">
            {{ 'LOCATION_SECTOR_DIALOG.TAB.MAINTENANCES.ITEM.VIEW' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="tab-maintenances__loading" *ngIf="this.isLoading">
    <mat-spinner color="primary" diameter="32"></mat-spinner>
  </div>
</div>
